import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { EnumErrorStates, ErrorObject } from '@inmoment/the-kitchen';

import {
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { generalNameValidator } from 'app/utils/customValidators';
import { ProjectCollection } from '../../models/project-collection.model';

@Component({
  selector: 'app-rename-collection',
  templateUrl: './rename-collection.component.html',
  styleUrls: ['./rename-collection.component.scss'],
  standalone: false,
})
export class RenameCollectionComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() collections: ProjectCollection[];
  @Input() collectionName: string;
  @Output() modalClosed: EventEmitter<any> = new EventEmitter();

  collection: ProjectCollection;
  collectionNameStatus: ErrorObject = { state: EnumErrorStates.SUCCESS, text: '' };
  displayName: string;

  ngOnInit() {
    this.collection = this.collections.find((c) => c.data.collectionName === this.collectionName);
    this.displayName = this.collection.data.displayName;
  }

  public onValidateCollectionName() {
    const exsistingNames = this.collections.reduce((filtered: string[], projectCollection) => {
      if (projectCollection.data.collectionName !== this.collectionName) {
        filtered.push(projectCollection.data.displayName);
      }

      return filtered;
    }, []);

    generalNameValidator(
      this.displayName.trim(),
      this.collectionNameStatus,
      'Collection',
      64,
      true,
      exsistingNames,
      false
    );
  }

  public collectionNameHasErrors(): boolean {
    return (
      this.collectionNameStatus.state !== EnumErrorStates.SUCCESS ||
      this.displayName.trim() === this.collection.data.displayName
    );
  }

  public async saveCollectionName() {
    const collectionData = this.collection.data;
    this.displayName = this.displayName.trim();
    collectionData.displayName = this.displayName;
    this.modalClosed.emit(collectionData);
  }

  public cancel(): void {
    this.modalClosed.emit(null);
  }
}
